import { render, staticRenderFns } from "./ScheduleItem.vue?vue&type=template&id=a282b174&scoped=true&"
import script from "./ScheduleItem.vue?vue&type=script&lang=js&"
export * from "./ScheduleItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a282b174",
  null
  
)

export default component.exports